import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'gatsby'
import arrowOrange from '../images/arrow-rust.svg'
import arrowCircleOrange from '../images/arrow-circle-rust.svg'
import styles from './arrow-link.module.scss'

const ArrowLink = ({
  className,
  text,
  to,
  external,
  newTab,
  color,
  arrowType,
  arrowPosition
}) => {
  const Arrow = () => (
    <img src={ arrowType === 'arrow-circle' ? arrowCircleOrange : arrowOrange } alt="" className={ styles.arrow } />
  )

  const Inner = () => (
    <>
      { arrowPosition === 'start' && (
        <Arrow />
      )}

      <span className={ styles.text }>{ text }</span>

      { arrowPosition === 'end' && (
        <Arrow />
      )}
    </>
  )

  if( external ) {
    return (
      <a
        href={ to }
        target={ newTab ? '__blank' : '' }
        className={ classNames( styles.link, className ) }
        style={{
          [ '--arrow-link-color' ]: color,
        }}
      >
        <Inner />
      </a>
    )
  }

  return (
    <Link
      to={ to }
      className={ classNames( styles.link, className ) }
      style={{
        [ '--arrow-link-color' ]: color,
      }}
    >
      <Inner />
    </Link>
  )
}

ArrowLink.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  external: PropTypes.bool,
  newTab: PropTypes.bool,
  arrowType: PropTypes.oneOf([ 'arrow', 'arrow-circle' ]),
  arrowPosition: PropTypes.oneOf([ 'start', 'end' ]),
}

ArrowLink.defaultProps = {
  className: '',
  external: false,
  newTab: false,
  arrowType: 'arrow-circle',
  arrowPosition: 'start',
}

export default ArrowLink